import { fetch } from 'app/models/Profile/actions'

const fetchProfileAPI = {
	url: '/api/profile/',
	actions: fetch,
	method: 'getJSON',
	handler: __SERVER__ && require('./fetch').default
};

export { fetchProfileAPI }



// WEBPACK FOOTER //
// ./src/server/api/Profile/api.ts